import React from 'react'

import {H3, P, Card} from '../../../../components/UI/index.js'
import {formSpacing, FormRow, FormStack, Toggle, Input} from '../../../../components/UI/forms/index.js'

export default function Licenses({reseller, onChange}) {
    return (
        <Card shadow style={{width: 600, padding: 20}}>
            <H3 style={{marginBottom: 36}}>Licenties</H3>

            <P style={{marginBottom: 24}}>Het aantal licenties bepaald hoeveel koeriers tegelijk actief kunnen zijn. Hieronder kun je instellen wat het maximum is waar je mee wil rijden.</P>

            <FormRow style={{marginBottom: formSpacing.section}}>
                <Toggle
                    label='Limiet op aantal licenties'
                    checked={reseller.settings.orders.maxLicenses}
                    onChange={(event) => {
                        const updatedReseller = {...reseller}
                        updatedReseller.settings.orders.maxLicenses = event.target.checked
                        onChange(updatedReseller, 'orders.maxLicenses')
                    }}
                />

                <FormStack style={{flex: 1}}>
                    {reseller.settings.orders.maxLicenses &&
                        <>
                            <Input
                                label='Maximaal aantal licenties'
                                type='number'
                                value={reseller.settings.orders.maxNrOfLicenses || 99}
                                min={1}
                                onChange={(event) => {
                                    const updatedReseller = {...reseller}
                                    updatedReseller.settings.orders.maxNrOfLicenses = parseInt(event.target.value) || 1
                                    onChange(updatedReseller, 'orders.maxNrOfLicenses')
                                }}
                            />
                        </>
                    }
                </FormStack>
            </FormRow>
        </Card>
    )
}
